import { useAuthStore } from '@/store/auth';

/**
 * Diretiva para controle de acesso baseado em role
 *
 * Uso:
 * v-role="'ADMIN'"              - Mostra apenas para admin
 * v-role="['ADMIN', 'MANAGER']" - Mostra para admin ou manager
 * v-role.not="'ADMIN'"          - Mostra para todos exceto admin
 * v-role.disable="'GUEST'"      - Desabilita para guests ao invés de esconder
 * v-role.hide="'USER'"          - Esconde ao invés de remover do DOM
 */
export const role = {
  mounted(el, binding) {
    const authStore = useAuthStore();
    const userRole = authStore.userRole;

    const roles = binding.value;
    let hasAccess = false;

    // Verifica se o usuário tem uma das roles especificadas
    if (Array.isArray(roles)) {
      hasAccess = roles.includes(userRole);
    } else {
      // Se for uma string única
      hasAccess = roles === userRole;
    }

    // Inverte o resultado se o modifier 'not' estiver presente
    if (binding.modifiers.not) {
      hasAccess = !hasAccess;
    }

    if (!hasAccess) {
      if (binding.modifiers.disable) {
        // Desabilitar elemento ao invés de esconder/remover
        el.disabled = true;
        el.classList.add('disabled');

        // Tratamento especial para links
        if (el.tagName === 'A') {
          el.classList.add('disabled-link');
          el.addEventListener('click', (e) => e.preventDefault());
          el.tabIndex = -1;
        }

        // Tratamento para elementos clicáveis
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.65';
      } else {
        // Comportamento padrão: esconder elemento
        // NOTA: Usamos display none em vez de removeChild porque o removeChild 
        // manual interfere com o virtual DOM do Vue e pode causar crashes.
        el.style.display = 'none';
      }
    } else {
      // Se tiver acesso e estiver escondido por uma execução anterior, mostra novamente
      if (el.style.display === 'none' && !binding.modifiers.hide) {
        el.style.display = '';
      }
    }
  },
  updated(el, binding) {
    // Re-executa a lógica quando a role ou o valor do binding mudar
    role.mounted(el, binding);
  },
};

export default {
  install(app) {
    app.directive('role', role);
  },
};
